import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatModule } from '../appModules/mat.module';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { MatTableDataSource } from '@angular/material/table';
import { ExportService } from '../shared/services/exportservice';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';


interface YearOption {
  value: string;
  Text: string;
}
@Component({
  selector: 'app-overall-result',
  imports: [ReactiveFormsModule, MatInputModule, MatModule, MatSelectModule, MatFormFieldModule, CommonModule],
  templateUrl: './overall-result.component.html',
  styleUrl: './overall-result.component.scss'
})
export class OverallResultComponent {

public cYear: number = new Date().getFullYear();

dataSource = new MatTableDataSource<any>([]);
  
displayedColumns: any = {
  label: [
    'SINO', 'GradeCardNumber', 'REG_NO', 'F_NAME', 'S_NAME', 'CRSECODE',
    'CA1_SUB1', 'CE1_SUB1', 'GP1_SUB1', 'GA1_SUB1', 'CP1_SUB1',
    'CA1_SUB2', 'CE1_SUB2', 'GP1_SUB2', 'GA1_SUB2', 'CP1_SUB2',
    'CA1_SUB3', 'CE1_SUB3', 'GP1_SUB3', 'GA1_SUB3', 'CP1_SUB3',
    'CA1_SUB4', 'CE1_SUB4', 'GP1_SUB4', 'GA1_SUB4', 'CP1_SUB4',
    'CA1_SUB5', 'CE1_SUB5', 'GP1_SUB5', 'GA1_SUB5', 'CP1_SUB5',
    'CA1_SUB6', 'CE1_SUB6', 'GP1_SUB6', 'GA1_SUB6', 'CP1_SUB6',
    'CA1_SUB7', 'CE1_SUB7', 'GP1_SUB7', 'GA1_SUB7', 'CP1_SUB7',
    'TCA1', 'TCE1', 'TCPE1', 'CCE1', 'SGPA1', 'NO_ATT1', 'CGPA1', 'PC1', 'RESULT1',
    'CA2_SUB1', 'CE2_SUB1', 'GP2_SUB1', 'GA2_SUB1', 'CP2_SUB1',
    'CA2_SUB2', 'CE2_SUB2', 'GP2_SUB2', 'GA2_SUB2', 'CP2_SUB2',
    'CA2_SUB3', 'CE2_SUB3', 'GP2_SUB3', 'GA2_SUB3', 'CP2_SUB3',
    'CA2_SUB4', 'CE2_SUB4', 'GP2_SUB4', 'GA2_SUB4', 'CP2_SUB4',
    'CA2_SUB5', 'CE2_SUB5', 'GP2_SUB5', 'GA2_SUB5', 'CP2_SUB5',
    'CA2_SUB6', 'CE2_SUB6', 'GP2_SUB6', 'GA2_SUB6', 'CP2_SUB6',
    'CA2_SUB7', 'CE2_SUB7', 'GP2_SUB7', 'GA2_SUB7', 'CP2_SUB7',
    'TCA2', 'TCE2', 'TCPE2', 'CCE2', 'SGPA2', 'NO_ATT2', 'CGPA2', 'PC2', 'RESULT2',
    'CA3_SUB1', 'CE3_SUB1', 'GP3_SUB1', 'GA3_SUB1', 'CP3_SUB1',
    'CA3_SUB2', 'CE3_SUB2', 'GP3_SUB2', 'GA3_SUB2', 'CP3_SUB2',
    'CA3_SUB3', 'CE3_SUB3', 'GP3_SUB3', 'GA3_SUB3', 'CP3_SUB3',
    'CA3_SUB4', 'CE3_SUB4', 'GP3_SUB4', 'GA3_SUB4', 'CP3_SUB4',
    'CA3_SUB5', 'CE3_SUB5', 'GP3_SUB5', 'GA3_SUB5', 'CP3_SUB5',
    'CA3_SUB6', 'CE3_SUB6', 'GP3_SUB6', 'GA3_SUB6', 'CP3_SUB6',
    'CA3_SUB7', 'CE3_SUB7', 'GP3_SUB7', 'GA3_SUB7', 'CP3_SUB7',
    'TCA3', 'TCE3', 'TCPE3', 'CCE3', 'SGPA3', 'NO_ATT3', 'CGPA3', 'PC3', 'RESULT3',
    'CA4_SUB1', 'CE4_SUB1', 'GP4_SUB1', 'GA4_SUB1', 'CP4_SUB1',
    'CA4_SUB2', 'CE4_SUB2', 'GP4_SUB2', 'GA4_SUB2', 'CP4_SUB2',
    'CA4_SUB3', 'CE4_SUB3', 'GP4_SUB3', 'GA4_SUB3', 'CP4_SUB3',
    'CA4_SUB4', 'CE4_SUB4', 'GP4_SUB4', 'GA4_SUB4', 'CP4_SUB4',
    'CA4_SUB5', 'CE4_SUB5', 'GP4_SUB5', 'GA4_SUB5', 'CP4_SUB5',
    'CA4_SUB6', 'CE4_SUB6', 'GP4_SUB6', 'GA4_SUB6', 'CP4_SUB6',
    'CA4_SUB7', 'CE4_SUB7', 'GP4_SUB7', 'GA4_SUB7', 'CP4_SUB7',
    'TCA4', 'TCE4', 'TCPE4', 'CCE4', 'SGPA4', 'NO_ATT4', 'CGPA4', 'PC4', 'RESULT4',
    'CA5_SUB1', 'CE5_SUB1', 'GP5_SUB1', 'GA5_SUB1', 'CP5_SUB1',
    'CA5_SUB11', 'CE5_SUB11', 'GP5_SUB11', 'GA5_SUB11', 'CP5_SUB11',
    'CA5_SUB12', 'CE5_SUB12', 'GP5_SUB12', 'GA5_SUB12', 'CP5_SUB12',
    'TCA5', 'TCE5', 'TCPE5', 'CCE5', 'SGPA5', 'NO_ATT5', 'CGPA5', 'PC5', 'RESULT5',
    'CA6_SUB1', 'CE6_SUB1', 'GP6_SUB1', 'GA6_SUB1', 'CP6_SUB1',
    'TCA6', 'TCE6', 'TCPE6', 'CCE6', 'SGPA6', 'NO_ATT6', 'CGPA6', 'PC6',
    'Month', 'Year', 'RESULT6', 'id', 'R5_SubP'
  ],
  
};

  public currentYear: Array<YearOption> = [
    { value: "0", Text: "Select" },
    { value: this.cYear.toString(), Text: this.cYear.toString() },
    { value: (this.cYear - 1).toString(), Text: (this.cYear - 1).toString() },
    { value: (this.cYear - 2).toString(), Text: (this.cYear - 2).toString() },
    { value: (this.cYear - 3).toString(), Text: (this.cYear - 3).toString() },
    { value: (this.cYear - 4).toString(), Text: (this.cYear - 4).toString() },
    { value: (this.cYear - 5).toString(), Text: (this.cYear - 5).toString() },
    { value: (this.cYear - 6).toString(), Text: (this.cYear - 6).toString() }
  ];

  gradeCardForm: FormGroup;
  startYear!: number;
  courseNames: any = [];
  results=null;
  isLoading: boolean = false;
  months: any;
  yearss: any

  CurrentSem: any = 0;

 ngOnInit(): void {
   
    this.gradeCardForm = this.fb.group({
      selectedMonth: ['', Validators.required],
      selectedYear: ['', Validators.required],
      selectCourse: ['', Validators.required],
    });

    this.getCourseDropDOwn();
    this.year_list();
    this.month_list();
  }


  
    constructor(private apiService: ApiService, private fb: FormBuilder, private common: CommonService, private exportService: ExportService) {
      this.startYear = new Date().getFullYear();
    }


  Display() {
    
    const data = this.gradeCardForm.value;
    this.isLoading = true;   
    this.apiService.post('results/overallResult', data).subscribe(response=>{
    if(response.status)
    {
       if (!response || Object.keys(response).length === 0) {
          alert('Result is not available for this Register Number for the selected Month and Year!');
          return;
        }
         this.isLoading = false;
   
         this.dataSource.data = response?.data || [];
    }
    });
 }



 getCourseDropDOwn() {
    this.apiService.get(`settings/courseDropDown`).subscribe((resp: any) => {
      if (resp.status) {
        this.courseNames = resp.data;

      } else {
        this.common.notification(resp.message);
      }
    });
  }
 

  
  year_list() {
    this.apiService.get('settings/year_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.yearss = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  month_list() {
    this.apiService.get('settings/month_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.months = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }
 
 Excel(){
  const exportData = this.dataSource.data.map((row) => {
    const flatRow: any = {};
    this.displayedColumns.label.forEach((col) => {
      flatRow[col] = row[col] ?? ''; // show empty string if value doesn't exist
    });
    return flatRow;
  });

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
  const workbook: XLSX.WorkBook = {
    Sheets: { 'GradeCard': worksheet },
    SheetNames: ['GradeCard']
  };
  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const fileName = 'GradeCard_' + new Date().getTime() + '.xlsx';
  const data: Blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  });
  FileSaver.saveAs(data, fileName);

  }
}
